<template>
    <div>

        <!-- label -->
        <div class="label" >{{ label }}</div>


        <!-- description span -->

        <!-- input -->
        <div>
            <treeselect
              :searchable="true"
              v-model="value"
              :show-count="true"
              :disable-branch-nodes="true"
              :close-on-select="true"
              :load-options="loadOptions"
              :placeholder="placeholder"
              :async="true"
              :options="options"
              @select="handleSelect"
              @input="handleInput"
              :id="id"
            >
              <label slot="option-label" slot-scope="{ node, shouldShowCount, count, labelClassName, countClassName }" :class="labelClassName">
                <span class="tree-select-email">{{ node.label }}</span>
                <span class="tree-select-count" v-if="shouldShowCount" :class="countClassName">({{ count }})</span>
              </label>
            </treeselect>


        </div>

        <!-- error span -->
        <span class="text-danger text-sm block mt-2">{{ errors.first(this.errorCorrelationKey) }}</span>

        <!-- hint span-->
        <span v-if="!errors.first(this.errorCorrelationKey) && this.hint" class="speakol-color text-sm block mt-2">{{ hint }}</span>

    </div>
</template>


<script>

import Treeselect, { ASYNC_SEARCH } from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import StringLimiter from '@/filters/StringLimiter'

export default {

  components: {
    Treeselect
  },
  filters: {
    StringLimiter
  },

  data () {

    return {
      EmailMaxLength: 23,
      errorCorrelationKey: '',
      options: [],
      value: null
    }
  },
  created () {
    this.errorCorrelationKey = this.label.toLowerCase()

    window.addEventListener('resize', this.handleResize)

    this.handleResize()
  },
  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  },

  name: 'speakol-tree-select',
  props: {
    label: {
      default: '',
      type: [String, Number]
    },
    placeholder: {
      default: 'placeholder',
      type: [String, Number]
    },
    type: {
      default: 'text',
      type: [String]
    },
    transformationFunction: {
      type: [Function]
    },
    fetchFunction: {
      type: [Function]
    },
    validation: {
      type: [String]
    },
    description: {},
    hint: { type: [String] },
    id: {}
  },

  methods: {
    handleResize () {
      if (window.innerWidth <= 768) {
        this.EmailMaxLength = 20
      } else {
        this.EmailMaxLength = 23
      }
    },
    async validate () {
      const correlationKey = this.errorCorrelationKey
      if (!this.value) {
        this.errors.add({
          field: correlationKey,
          msg: `The ${correlationKey} is required`
        })
      }
      return !this.errors.has(correlationKey)

    },

    async addValidationError (validationMessage) {
      const correlationKey = this.errorCorrelationKey
      setTimeout(() => {
        this.errors.add({
          field: correlationKey,
          msg: validationMessage
        })
      }, 0)
    },

    setDefault () {
      this.value = null
      this.errors.clear()
    },

    loadOptions ({ action, searchQuery = '', callback }) {
      if (action === ASYNC_SEARCH && searchQuery.length >= 3) {
        if (this.debounce != null)
          clearTimeout(this.debounce);
        this.debounce = setTimeout(() => {this.fetchFunction(searchQuery)
          .then((list) => {
            const transformedList = list.map((item) => {
              return this.transformationFunction(item)
            })
            callback(null, transformedList)
          })
          .catch(callback)}, 200);
      } else {
        callback(null, [])
      }
    },
    handleSelect (value) {
      this.errors.clear()
      this.$emit('select', value)
    },
    handleInput (value) {
      this.errors.clear()
      this.$emit('input', value)
    }
  }


}


</script>


<style lang="scss" scoped>
  .label {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 24px;
    color: #2c2c2c;
  }

  .speakol-color {
    color: #0092d7;
  }

  /deep/ .vue-treeselect__control {
    height: 40px;
    background: #fff;
    border: 1px solid rgba(0, 0, 0, 0.15);
    box-sizing: border-box;
    border-radius: 4px;
  }

  /deep/ .vue-treeselect__control-arrow-container {
    display: none;
  }

  /deep/ .vue-treeselect__x-container {
    display: none;
  }

  .vue-treeselect__label {
    padding: 7px;
  }

  .tree-select-email {
    text-overflow: ellipsis;
    overflow: hidden;
    width: 210px;
    white-space: nowrap;
    float: left !important;
  }

  .tree-select-count {
    float: right;
  }

  @media (max-width: 576px) {
    .tree-select-email {
      text-overflow: ellipsis;
      overflow: hidden;
      width: 170px;
      white-space: nowrap;
      float: left !important;
    }

    .tree-select-count {
      float: right;
    }
  }
</style>
